type Props = {
    name: string | undefined;
    surname: string | undefined;
};

export const getUserName = ({ name, surname }: Props) => {
    if (!name && !surname) {
        return '';
    }

    if (!surname) {
        return name;
    }

    return `${name} ${surname[0]}`;
};
